/**
 * Application Version Configuration
 * 
 * Update this file when releasing new versions to GitHub
 * The version will be displayed in the Settings page
 */

export const APP_VERSION = {
  version: '1.4.0',
  buildDate: '2026-02-07',
  releaseNotes: [
    'Add Gudu Sales section',
    'Add stripe webhook',
    'Add gudu sql omni licensing system',
    'Add gudu sql omni licensing system',
    'Add gudu sql omni licensing system'
  ],
  features: [
    'Secure file upload to S3',
    'User and group management',
    'Download management',
    'Product management',
    'Email notifications'
  ]
};

export const getVersionInfo = () => {
  return {
    ...APP_VERSION,
    fullVersion: `v${APP_VERSION.version}`,
    buildInfo: `Built on ${APP_VERSION.buildDate}`
  };
}; 